import { Button } from '@/components/ui-kit/button';
import { Folder, Trash2 } from 'lucide-react';
import { IFolder } from '@/modules/gpt-chats/types/kb.service.type';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface AgentConfigFolderCardProps {
  folder: IFolder;
  onRemove: (folderId: string) => void;
}

export const AgentConfigFolderCard = ({ folder, onRemove }: AgentConfigFolderCardProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-between rounded-lg border p-4">
      <div className="flex min-w-0 flex-1 items-center gap-3">
        <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded bg-primary/10 text-primary">
          <Folder className="h-5 w-5" />
        </div>
        <Link to={`/ai/knowledge-base/${folder._id}`} className="group min-w-0 flex-1">
          <div className="truncate font-medium text-high-emphasis transition-colors group-hover:text-primary">
            {folder.Name || t('UNNAMED_FOLDER')}
          </div>
          <div className="line-clamp-1 break-all text-sm text-medium-emphasis transition-colors group-hover:text-primary/80">
            {folder.Description || t('NO_DESCRIPTION')}
          </div>
        </Link>
      </div>
      <div className="flex flex-shrink-0 items-center gap-2">
        <Button
          variant="outline"
          onClick={() => onRemove(folder._id)}
          className="text-medium-emphasis hover:text-error"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
